export default class Lock {
	/**
	 * Instantiates a Lang with default values
	 *
	 * @class
	 * @param {any} lock
	 */
	constructor(lock = undefined) {
		/** @type {Date | undefined} */
		this.date = lock?.date ? new Date(lock.date) : undefined;

		/** @type {import('@knitiv/api-client-javascript').KNode | undefined} */
		this.kid = lock?.kid;

		/** @type {boolean} */
		this.locked = lock?.locked ?? false;

		/** @type {{kid: import('@knitiv/api-client-javascript').KNode, fullname: string} | undefined} */
		this.profil = lock?.profil;
	}
}
